var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 195 224.63",
    style: {
      enableBackground: "new 0 0 195 224.63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0B63B0;}\n\t.st1{fill:#4CC9F5;}\n\t.st2{fill:#2DABE2;}\n\t.st3{fill:#B3E3F3;}\n\t.st4{fill:#771213;}\n\t.st5{fill:#237FC3;}\n\t.st6{fill:#1264B0;}\n\t.st7{fill:#01486D;}\n\t.st8{fill:#2EAAE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "195,168.63 97.63,224.63 0.14,168.87 97.5,112.87  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "97.5,112.87 0.14,168.87 0,56 97.36,0  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "97.36,0 194.86,55.77 195,168.63 97.5,112.87  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.14,119.2 51.65,139.24 25.94,70.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "48.75,27.96 25.94,70.78 97.36,47.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "25.94,70.78 25.94,70.78 25.94,70.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "25.94,70.78 25.94,70.78 51.65,139.24 97.36,47.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "194.79,119.2 143.28,139.24 168.99,70.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "146.18,27.96 168.99,70.78 97.57,47.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "168.99,70.78 168.99,70.78 143.28,139.24 97.57,47.24  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.65,
    y: 139.24,
    className: "st7",
    width: 91.63,
    height: 59.14
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "51.65,139.24 143.28,139.24 97.57,198.38  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond5);
export default __webpack_public_path__ + "static/media/diamond-5.de2385af869f8ace7df343ed7ef1590a.svg";
export { ForwardRef as ReactComponent };